import type { AlertSeverity } from '../review/schema';
import { Icon, type IconName } from '../ui/Icon';
import { SEVERITY_LABELS } from './severity';
import styles from './alerts.module.css';

const SEVERITY_CLASS: Readonly<Record<AlertSeverity, string | undefined>> = {
  info: styles.severityInfo,
  warning: styles.severityWarning,
  error: styles.severityError,
};

/** Redundant with the label by design - the icon reinforces the tone, it never replaces the
 * text (`ui-requirements.md` §10.4), so each one is hidden from assistive tech. */
const SEVERITY_ICON: Readonly<Record<AlertSeverity, IconName>> = {
  info: 'info-circle',
  warning: 'alert-triangle',
  error: 'x-circle',
};

export interface SeverityBadgeProps {
  readonly severity: AlertSeverity;
}

/** `Severity` shown as an icon plus text plus a tone, matching `history/StatusBadge.tsx`'s
 * convention - never color alone. */
export function SeverityBadge({ severity }: SeverityBadgeProps) {
  return (
    <span className={`${styles.severityBadge ?? ''} ${SEVERITY_CLASS[severity] ?? ''}`}>
      <Icon name={SEVERITY_ICON[severity]} size={12} strokeWidth={2.6} />
      {SEVERITY_LABELS[severity]}
    </span>
  );
}
